import { graphql } from '@/__generated__';
import { useQueryStable } from '../useQueryStable';

export const GetRecommendationsCount = graphql(/* GraphQL */ `
  query RecommendationsCount(
    $environmentId: BigInt!
    $first: Int!
    $filter: RuleFilter
  ) {
    recommendations(environmentId: $environmentId) {
      lastUpdatedAt
      rules(first: $first, filter: $filter) {
        totalCount
      }
    }
  }
`);

type RecommendationsCountParams = {
  environmentId: number | null | undefined;
  uniqueId: string | null | undefined;
  pause?: boolean;
};

export const useRecommendationsCount = ({
  environmentId,
  uniqueId,
  pause,
}: RecommendationsCountParams) => {
  const query = useQueryStable({
    query: GetRecommendationsCount,
    variables: {
      first: 1,
      environmentId: environmentId!,
      filter: {
        uniqueIds: uniqueId ? [uniqueId] : null,
      } as any,
    },
    pause: pause || !environmentId,
  });

  return query;
};
